import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function CategoryNav({ categories, selected, onSelect }) {
  const max = Math.max(1, ...categories.map((c) => c.distinctiveness || 0));
  return (
    <nav aria-label="Categories" className="rounded-lg border bg-white">
      <div className="px-3 py-2 text-xs uppercase tracking-wide text-gray-500 border-b">
        Categories ({categories.length})
      </div>
      <ul className="py-1">
        <li>
          <button
            type="button"
            onClick={() => onSelect('')}
            className={`w-full text-left px-3 py-1.5 text-sm flex items-center justify-between hover:bg-gray-50 ${
              !selected ? 'bg-blue-50 text-[#0062FB] font-medium' : 'text-gray-800'
            }`}
          >
            <span>All features</span>
            {!selected ? <ChevronRight className="h-4 w-4" /> : null}
          </button>
        </li>
        {categories.map((c) => {
          const active = selected === c.id;
          const w = c.distinctiveness != null ? Math.max(4, Math.round((100 * c.distinctiveness) / max)) : 0;
          return (
            <li key={c.id}>
              <button
                type="button"
                onClick={() => onSelect(c.id)}
                title={c.distinctiveness != null ? `Distinctiveness ${c.distinctiveness.toFixed(1)} pts · top: ${c.top_feature_label}` : c.label}
                className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-50 ${
                  active ? 'bg-blue-50 text-[#0062FB] font-medium' : 'text-gray-800'
                }`}
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="truncate">{c.label}</span>
                  <span className="text-xs text-gray-400 tabular-nums">{c.n_features}</span>
                </div>
                <div className="mt-1 h-1 rounded bg-gray-100 overflow-hidden">
                  <div className="h-full rounded bg-[#0062FB]/70" style={{ width: `${w}%` }} />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
